import { useNonReligiousMode } from '@fs/zion-permissions'
import { Row, Skeleton } from '@fs/zion-ui'
import React from 'react'
import { useShowTempleContext } from '../../../providers/ShowTempleContext'

type Props = {
  buttonSize: 'lg' | 'md' | 'xs' | 'sm' | 'xl'
}

export default function IndicatorsRowSkeleton({ buttonSize }: Props): JSX.Element {
  const [showTemple] = useShowTempleContext()
  // Use only the flag value itself — not loading/error guards — so the skeleton shows
  // the temple indicator while NRM data is still fetching (matches the loaded layout).
  const [nonReligiousMode] = useNonReligiousMode()
  const showTempleIndicator = showTemple && !nonReligiousMode

  return (
    <Row gutters="xxs">
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      {showTempleIndicator && <Skeleton.IconButton size={buttonSize} />}
    </Row>
  )
}
